// Core
import { 
  Route, 
  Switch, 
  Redirect, 
  useRouteMatch, 
} from 'react-router-dom';

// Chakra imports
import { 
  Box,
} from '@chakra-ui/react';

// Components
import BasePrice from './BasePrice';
import BasePriceEdit from './BasePriceEdit';

function BasePrices(props) {
  const { path } = useRouteMatch();

  return (
    <>
      <Box>
        <Switch>
          <Route path={`${path}/:id(new|\\d+)`} render={() => <BasePriceEdit/>}/>
          <Route path={`${path}`} render={() => <BasePrice/>}/>
          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>
      </Box>
    </>
  );
}

export default BasePrices;